import { useState } from "preact/hooks"
import { MappedImage, Modal } from "src/utils/fw"

export default function GRID(props) {
    // console.log(props.links)
    return <div style={{
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        gap: props.style?.gap || "0",
        top: props.style?.top || "0%",
        left: props.style?.left || "auto",
        right: props.style?.right || "auto",
        width: props.style?.width,
        height: props.style?.height
    }}>

    { props.links?.map((row, rowNb) => {
        return <div style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "stretch",
            gap: props.style?.columnGap
        }}>{row.map((link, linkNb) => {
        
        const [open, setOpen] = useState(false)
        // console.log(link)

        const ModalContent = props.isModal && props.modalContent ? props.modalContent(link, rowNb, linkNb) : <></>
        return <>
                <a 
                    key={`${link[0]}-${props.roomName}`}
                    style={{
                        display: "block",
                        height: "100%",
                        width: "100%",
                        cursor: "pointer"
                    }} 
                    target={props.isVideo ? undefined : "_ blank"}
                    className="_gtm-event GRID_LINK"
                    data-event-category={props.roomName}
                    data-event-action="Link Click"
                    data-event-label={link[0]}
                    onClick={() => {
                        if (link.length > 2) props.onClickExtra?.call(null, link[2])
                        if (props.isVideo || props.isModal) setOpen(true)
                    }}
                    id={link[0]}
                    href={(props.isVideo || props.isModal) ? undefined : link[1]}
                />
                { open && <Modal dismissHTML="X" dismiss={() => setOpen(false)}>
                    { <ModalContent/> }
                    { props.isVideo && <iframe src={link[1]} allow="autoplay" style={{
                        border: 0,
                        borderRadius: "16px",
                        width: "66em",
                        marginTop: "22px",
                        aspectRatio: "16/9"
                    }} />}
                </Modal>}
            </>
        })}
        </div>
    }) }

    </div>
}

export function GRIDPopup(props) {
    const links = []

    if (props.ACTION_BTN) {
        links.push({
            href: props.ACTION_BTN || "#",
            isExternal: true,
            label: props.ACTION_BTN_LABEL || "Action BTN",
            target: "_blank",
            ...props.ACTION_BTN_style
        })
    }

    return <MappedImage imageURL={props.image} links={links}>
        { props.GRID && props.useGRID && <GRID {...props.GRID} roomName={props.roomName} />}
        { props.children || <></> }
    </MappedImage>
}